import Ajax from '../js/common/ajax';
import Qs from "qs";

/**
 * 部门汇总接口
 */
export default {
    jingying: {
        list(accountDate) {
            return Ajax.get("/jingyingbumen", {accountDate})
        },
        list1() {
            return Ajax.get("/jingyingbumen/list")
        },
        load(id) {
            return Ajax.get(`/jingyingbumen/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/jingyingbumen/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/jingyingbumen/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/jingyingbumen`, params)
        },
        update(params = {}) {
            return Ajax.put(`/jingyingbumen`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/jingyingbumen/batch-update`, params)
        }
    },
    guanli: {
        list(accountDate) {
            return Ajax.get("/guanLiBuMen", {accountDate})
        },
        load(id) {
            return Ajax.get(`/guanLiBuMen/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/guanLiBuMen/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/guanLiBuMen/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/guanLiBuMen`, params)
        },
        update(params = {}) {
            return Ajax.put(`/guanLiBuMen`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/jingyingbumen/batch-update`, params)
        }
    },
    guanlick: {
        list(accountDate) {
            return Ajax.get("/qzguanlick", {accountDate})
        },
        load(id) {
            return Ajax.get(`/qzguanlick/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/qzguanlick/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/qzguanlick/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/qzguanlick`, params)
        },
        update(params = {}) {
            return Ajax.put(`/qzguanlick`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/qzguanlick/batch-update`, params)
        }
    },
    guanlixj: {
        list(accountDate) {
            return Ajax.get("/qzguanlixj", {accountDate})
        },
        load(id) {
            return Ajax.get(`/qzguanlixj/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/qzguanlixj/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/qzguanlixj/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/qzguanlixj`, params)
        },
        update(params = {}) {
            return Ajax.put(`/qzguanlixj`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/qzguanlixj/batch-update`, params)
        }
    },
     jingyingck: {
        list(accountDate) {
            return Ajax.get("/qzjingyingck", {accountDate})
        },
        load(id) {
            return Ajax.get(`/qzjingyingck/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/qzjingyingck/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/qzjingyingck/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/qzjingyingck`, params)
        },
        update(params = {}) {
            return Ajax.put(`/qzjingyingck`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/qzjingyingck/batch-update`, params)
        }
    },
     jingyingxj: {
        list(accountDate) {
            return Ajax.get("/qzjingyingxj", {accountDate})
        },
        load(id) {
            return Ajax.get(`/qzjingyingxj/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/qzjingyingxj/${id}`)
        },
         batchDelete(params = {}) {
             return Ajax.post(`/qzjingyingxj/batchDelete`, params)
         },
        save(params = {}) {
            return Ajax.post(`/qzjingyingxj`, params)
        },
        update(params = {}) {
            return Ajax.put(`/qzjingyingxj`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/qzjingyingxj/batch-update`, params)
        }
    },
    tongbuguanli: {
        list(accountDate) {
            return Ajax.get("/tbguanli", {accountDate})
        },
        load(id) {
            return Ajax.get(`/tbguanli/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/tbguanli/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/tbguanli/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/tbguanli`, params)
        },
        update(params = {}) {
            return Ajax.put(`/tbguanli`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/tbguanli/batch-update`, params)
        }
    },
    tongbujingying: {
        list(accountDate) {
            return Ajax.get("/tbjingying", {accountDate})
        },
        load(id) {
            return Ajax.get(`/tbjingying/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/tbjingying/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/tbjingying/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/tbjingying`, params)
        },
        update(params = {}) {
            return Ajax.put(`/tbjingying`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/tbjingying/batch-update`, params)
        }
    },
    yucunjingying: {
        list(accountDate) {
            return Ajax.get("/ycjingying", {accountDate})
        },
        load(id) {
            return Ajax.get(`/ycjingying/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/ycjingying/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/ycjingying/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/ycjingying`, params)
        },
        update(params = {}) {
            return Ajax.put(`/ycjingying`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/ycjingying/batch-update`, params)
        }
    },
    yucunguanli: {

        list(accountDate) {
            return Ajax.get("/ycguanli", {accountDate})
        },
        load(id) {
            return Ajax.get(`/ycguanli/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/ycguanli/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/ycguanli/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/ycguanli`, params)
        },
        update(params = {}) {
            return Ajax.put(`/ycguanli`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/ycguanli/batch-update`, params)
        }
    },
    gudingzichan: {
        list(accountDate) {
            return Ajax.get("/gudingzichan", {accountDate})
        },
        load(id) {
            return Ajax.get(`/gudingzichan/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/gudingzichan/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/gudingzichan/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/gudingzichan`, params)
        },
        update(params = {}) {
            return Ajax.put(`/gudingzichan`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/gudingzichan/batch-update`, params)
        }
    },
    zichanfuzhai: {
        list(accountDate) {
            return Ajax.get("/ziChanFuZhai", {accountDate})
        },
        load(id) {
            return Ajax.get(`/ziChanFuZhai/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/ziChanFuZhai/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/ziChanFuZhai/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/ziChanFuZhai`, params)
        },
        update(params = {}) {
            return Ajax.put(`/ziChanFuZhai`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/ziChanFuZhai/batch-update`, params)
        }
    },
    qzymfentan: {
        list(accountDate) {
            return Ajax.get("/qzymfentan", {accountDate})
        },
        load(id) {
            return Ajax.get(`/qzymfentan/${id}`)
        },
        delete(id) {
            return Ajax.delete(`/qzymfentan/${id}`)
        },
        batchDelete(params = {}) {
            return Ajax.post(`/qzymfentan/batchDelete`, params)
        },
        save(params = {}) {
            return Ajax.post(`/qzymfentan`, params)
        },
        update(params = {}) {
            return Ajax.put(`/qzymfentan`, params)
        },
        batchUpdate(params = {}) {
            return Ajax.put(`/qzymfentan/batch-update`, params)
        }
    },
}